export default __webpack_public_path__ + "static/media/ic-droparrow.8d691df9.svg";